define('common/baseItemView',['require','app/app','glu/itemView'],function(require) {
	'use strict';

	var App = require('app/app'),
		ItemView = require('glu/itemView');


	return ItemView.extend({

		isViewOnly: function() {
			return App.user.isReadOnly();
		},

		isBasicUser: function() {
			return App.user.isBasicUser();
		},

		canViewReports: function() {
			return true;
		},

		canViewMonitors: function() {
			return (App.user.isInternalUser() || App.user.isAdvanceUser());
		},

		canAddWidgets: function() {
			return !App.user.isInternalUser();
		},

		isInternalUser: function() {
			return App.user.isInternalUser();
		}

	});
});

